import { capitalizeFirstLetter } from '@src/helpers/Helpers';
import React, { FC } from 'react';
import styled from 'styled-components';

const StyledText = styled.p`
	color: '#00C853';
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.28px;
`;

interface Props {
	status: string;
	style?: React.CSSProperties;
}

interface Status {
	[key: string]: string;
}

const StyledStatus: FC<Props> = ({ status, style = {} }) => {
	const statusColor: Status = {
		accepted: '#00C853',
		partially_accepted: '#F26184',
		rejected: '#F26184',
		pending: 'rgb(230, 174, 6)',
	};
	const statusTitle: Status = {
		accepted: 'Accepted',
		partially_accepted: 'Partially Accepted',
		rejected: 'Rejected',
		pending: 'Pending',
	};
	return (
		<StyledText style={{ ...style, color: statusColor?.[status?.toLowerCase()] }}>
			{statusTitle?.[status?.toLowerCase()]}
		</StyledText>
	);
};

export default StyledStatus;
